"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreNav2 = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const react_1 = require("react");
const components_1 = require("./StoreNav2/components");
const StoreNav2ActionsView_1 = require("./StoreNav2ActionsView");
const StoreNav2Menu_1 = require("./StoreNav2Menu");
const components_2 = require("../common/components");
const styles = {
    mobileLogo: (0, app_1.css) `
    display: none;
    @media ${app_1.mobile} {
      display: block;
    }
  `,
    logo: (0, app_1.css) `
    display: block;
    @media ${app_1.mobile} {
      display: none;
    }
  `,
};
function StoreNav2({ menu: Menu = StoreNav2Menu_1.StoreNav2Menu, actions: Actions = StoreNav2ActionsView_1.StoreNav2ActionsView, logo: Logo = svg_1.SvgLogo, mobileLogo: MobileLogo = svg_1.SvgLogo, wrapper, className, }) {
    const Wrapper = wrapper !== null && wrapper !== void 0 ? wrapper : react_1.Fragment;
    return ((0, jsx_runtime_1.jsx)(components_1.Nav2, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsx)(Wrapper, { children: (0, jsx_runtime_1.jsxs)(components_1.Nav2Wrap, { children: [(0, jsx_runtime_1.jsx)(Menu, {}), (0, jsx_runtime_1.jsxs)(components_2.LogoWrapper, Object.assign({ href: "/" }, { children: [(0, jsx_runtime_1.jsx)(MobileLogo, { css: styles.mobileLogo }), (0, jsx_runtime_1.jsx)(Logo, { css: styles.logo })] })), (0, jsx_runtime_1.jsx)(Actions, {})] }) }) })));
}
exports.StoreNav2 = StoreNav2;
